import React from 'react';
import { FullscreenButton as FullscreenButtonComponent } from '@unboared/design.all';
import { useFullscreen } from '@unboared/utils.fullscreen'

export const FullscreenButton = ({ size = 40 }: { size?: number }) => {
  const { isFullscreen, toggleFullscreen } = useFullscreen();

  return <FullscreenButtonComponent size={size} onPress={toggleFullscreen} active={!isFullscreen} />
}